import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import { AcountingHeading } from './common/AcountingHeading'
import { appendToUrl, diffInMonths, focusElemnt, getLocalData, isEmpty, navigation3, removeDuplicatesFromArray } from '../../common/helper'
import { getCreditTransactionData, getOwnChildBranches, getReportBranchList } from '../../../store/reports/reports_action'
import { useEffect } from 'react'
import * as URL from '../Reports/oldReportsUrls'
import { getBranchConfigOrEwbillinfo, updateAlertError, updateModal } from '../../../store/common/common_action'
import TableViewCreditTransaction from './TableViewCreditTransaction'
import { GetRequest, PostRequest, PostRequestCachedV3 } from '../../common/api'
import { urls } from '../../common/constants'
import ManageColumns from '../../common/ManageColumnsUI'
import { creditTransReportColumn, creditTransReportColumnForBoth, creditTransReportColumnFormattedLRNO, creditTransReportColumnWithNewCommission } from './common/AcountingConstants'
const CreditReport = (props) => {
  const {
    data: { common, reports },
    getOwnChildBranches,
    getBranchConfigOrEwbillinfo,
    getReportBranchList,
    getCreditTransactionData,
    updateAlertError,
    updateModal,
  } = props
  const { ownChildBranches1, reportBranchList, creditTransactionReportData } = reports
  const { loginData, citywiseBranchList, roleRights, showModal, modalType,companySettings } = common
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
  const BranchCrlTxnsPortrait  = companySettings?.[0]?.IsBranchCrlTxnsPortrait  || 0
  const reportName = 'Branch Credit Limit Transaction'
  const [stateList, setStateList] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selState, setSelState] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [isExpanded, setIsExpanded] = useState(false)
  const [resetFlag, setResetFlag] = useState(false)
  const [resetCity, setResetCity] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  const [creditTransTableData, setCreditTransTableData] = useState([])
  const selectedFields = manageColumn?.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
  useEffect(() => {
    focusElemnt(id.creditTransFromDate)
  }, [])
  // const BranchCrlTxnsPortrait =1
  useEffect(() => {
    if (!isEmpty(loginData)) {
      let creditTransReportColumnHeader=UseFormattedLRinReports===0||UseFormattedLRinReports===1?creditTransReportColumn:UseFormattedLRinReports===2?creditTransReportColumnFormattedLRNO:creditTransReportColumnForBoth
      if (loginData?.intCompanyID === 406) {
        if (BranchCrlTxnsPortrait === 1) {
            creditTransReportColumnWithNewCommission = creditTransReportColumnWithNewCommission.filter((item) => item.isMandatory === true)
          }
        setManageColumn(creditTransReportColumnWithNewCommission)
      } else {
        if (BranchCrlTxnsPortrait === 1) {
            creditTransReportColumnHeader = creditTransReportColumnHeader.filter((item) => item.isMandatory === true)
          }
        setManageColumn(creditTransReportColumnHeader)
      }
    }
  }, [loginData,BranchCrlTxnsPortrait])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const branchData = {
        intUserID: loginData?.intUserID,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
      setSelSourceBranch({ BranchName: loginData?.strBranchName, BranchID: loginData?.intBranchID })
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(roleRights)) {
      if (roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin) {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: 0,
          intIsActive: 1,
        }
        PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, obj, true, 24 * 60 * 60).then((res) => {
          if (res.status === 'Success') {
            const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
            setSourceBranchList(filteredList);
          }
        })
      } else if (!roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport && roleRights?.Table1?.[0]?.AllowBranchInchargeRights) {
        const obj = {
          CompanyID: loginData?.intCompanyID,
          CityID: loginData?.intCityID,
          UserID: loginData?.intUserID,
          BranchID: loginData?.intBranchID,
          Mode: 1,
        }
        GetRequest(urls.getReportBranchList, obj).then((res) => {
          if (res.status == 'Success') {
            setSourceBranchList(res?.Data?.Table)
          }
        })
      } else {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: loginData?.intCityID,
          intIsActive: 1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
          if (res.status === 'Success') {
            const filteredList = res?.Data?.Table?.filter(item => item.IsCargoCreditLimit === 1);
            setSourceBranchList(filteredList);
            //setSourceBranchList(res?.Data?.Table)
          }
        })
      }
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (creditTransactionReportData.length > 0) {
      const creditTransactionReportUpdatedData = creditTransactionReportData.map((val) => {
        const bkgDateTime = val.BookingDateTime !== ''
          ? `${moment(val.BookingDateTime).format('DD-MMM-YY')}\n${new Date(val.BookingDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
          : 'N/A';
        return {
          ...val,
          LRNO: val.BookingDateTime !== '' ? val.LRNO : 'N/A',
          BookingDateTime: bkgDateTime,
        };
      });
      setCreditTransTableData(creditTransactionReportUpdatedData)
    }
  }, [creditTransactionReportData])
  useEffect(() => {
    if (!isEmpty(ownChildBranches1)) {
      if (ownChildBranches1?.length > 0) {
        const { intBranchCityID, strCityName } = loginData;
        const { stateList } = ownChildBranches1.reduce(
          (acc, val) => {
            const { StateID, StateName } = val
            if (!acc.statesMap.has(StateID)) {
              acc.statesMap.set(StateID, { StateID, StateName })
              acc.stateList.push({ StateID, StateName })
            }
            return acc
          },
          {
            statesMap: new Map(),
            stateList: [],
          }
        )
        setStateList([{ StateName: 'All', StateID: 0 }, ...stateList])
        setSourceCityList([{ CityName: 'All', CityID: 0 }, ...ownChildBranches1])
        const selectedState = ownChildBranches1.find(obj => obj.CityID === intBranchCityID);
        setSelState({
          StateName: selectedState?.StateName || '',
          StateID: selectedState?.StateID || '',
        });
        setSelSourceCity({ CityName: strCityName, CityID: intBranchCityID })
      } else {
        setStateList([])
        setSourceCityList([])
        setSelState('')
        setSelSourceCity('')
      }
    }
  }, [ownChildBranches1])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      //setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
    }
  }, [roleRights, loginData])
  const handleClick1 = () => {
    if (selState == '' || selState == ' ') {
      updateAlertError({ show: true, msg: 'Select State', nextId: '' })
    }
    if (selSourceCity == '' || selSourceCity == ' ') {
      updateAlertError({ show: true, msg: 'Select City', nextId: '' })
    }
    if (selSourceBranch == '' || selSourceBranch == ' ') {
      updateAlertError({ show: true, msg: 'Select Branch', nextId: '' })
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'Selected Date Range is More Then One Month', nextId: '' })
    } else {
      setIsExpanded(true)
      const obj = {
        CompanyID: loginData?.intCompanyID,
        BranchID: selSourceBranch?.BranchID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
      }
      getCreditTransactionData(obj)
    }
  }
  const handleClick2 = () => {
    let url = URL.creditTransactionReport
    const urlData = URL.creditTransactionReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.intBranchID = selSourceBranch?.BranchID
    urlData.strSelBranch = selSourceBranch?.BranchName
    urlData.fromdate = fromDate.format('DD-MMM-YYYY')
    urlData.todate = toDate.format('DD-MMM-YYYY')
    urlData.intAllowExportToExcel = 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const onSaveColumns = (items) => {
    setManageColumn(items)
    localStorage.setItem(loginData?.intCompanyID === 406 ? 'creditTransReportColumnWithNewCommission' : 'creditTransReportColumnHeader', JSON.stringify(items))
    // localStorage.setItem('creditTransReport', JSON.stringify(items))
  }
  const getCityList = () => {
    if (!selState.StateID) {
      return sourceCityList || []
    } else {
      const filteredCities = sourceCityList.filter((state) => state.StateID === selState.StateID)
      return [{ CityName: 'All', CityID: 0 }, ...filteredCities]
    }
  }
  const getBranchList = () => {
    const { CityID } = selSourceCity;
    const { StateID } = selState;
    if (CityID) {
      return sourceBranchList?.filter(branch => branch.CityID === CityID) || [];
    }
    if (StateID) {
      return sourceBranchList?.filter(branch => branch.StateID === StateID) || [];
    }
    return sourceBranchList || [];
  };
  function subtractDaysFromDate(date, days) {
    const formattedDate = moment(date, 'YYYY-MM-DD').subtract(days, 'days').format('YYYY-MM-DD')
    return formattedDate
  }
  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0] // Returns the date in "YYYY-MM-DD" format
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompany}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              minWidth="250px"
              width="300px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Booking Date`}
              // name={'from_date'}
              id={id.creditTransFromDate}
              // value={fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
              //   width="210px"
              startDate={'2022-01-01'}
              //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              // name={'to_date'}
              id={id.toDate}
              // value={toDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt(disableBtn ? id.creditTransSplitButton : id.stateId)
              }}
              // width="210px"
              startDate={'2022-01-01'}
              //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
              endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={'Select State'}
              data={stateList || []}
              defaultvalue={selState?.StateName}
              //defaultvalue={stateList.filter((obj) => obj.CityID === loginData?.intBranchCityID)?.StateName}

              idKey={`StateID`}
              dataKey={`StateName`}
              onSelect={(val) => {
                setSelState(val)
                setIsExpanded(false)
                setResetCity(true)
              }}
              isObjArr={true}
              //searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.srcCity}
              prevId={id.toDate}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcCity}
              label={'Select City'}
              data={getCityList()}
              defaultvalue={selSourceCity?.CityName}
              idKey={`CityID`}
              dataKey={`CityName`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceCity(val)
                setResetCity(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.srcBranch}
              prevId={id.stateId}
              resetFlag={resetCity || resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.srcBranch}
              label={'Select Branch'}
              data={getBranchList()}
              defaultvalue={selSourceBranch?.BranchName}
              idKey={`BranchID`}
              dataKey={`BranchName`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceBranch(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="310px"
              nextId={id.creditTransSplitButton}
              prevId={id.srcCity}
              resetFlag={resetCity || resetFlag}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) => navigation3(e, isExpanded ? 'creditTransExcelBtn' : id.creditTransFromDate, () => handleClick1())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              //hideToggle={false}
              id1={id.creditTransSplitButton}
              prevID={disableBtn ? id.toDate : id.srcBranch}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item
            sx={{ ...sx.itemsx }}
            onClick={() => {
              setResetFlag(!resetFlag)
            }}
          >
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
      <Item>
        {isExpanded ? (
          <TableViewCreditTransaction
            reportData={creditTransTableData}
            loginData={loginData}
            fromDate={fromDate}
            toDate={toDate}
            company={loginData?.strCompanyName}
            StateName={selState?.StateName}
            city={selSourceCity?.CityName}
            branch={selSourceBranch?.BranchName}
            updateModal={updateModal}
            columns={manageColumn}
            selectedFields={selectedFields}
            UseFormattedLRinReports={UseFormattedLRinReports}
          />
        ) : (
          ''
        )}
      </Item>
      {showModal && modalType === 'showManageColumnForCreditTrans' && (
        <ManageColumns
          headers={manageColumn}
          onSave={onSaveColumns}
          updateModal={updateModal}
          headTxt={`Columns for Branch Credit Limit Transaction Report`}
        />
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getOwnChildBranches,
  getBranchConfigOrEwbillinfo,
  getReportBranchList,
  getCreditTransactionData,
  updateAlertError,
  updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(CreditReport)
